import { draggableIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const Move = createIcon({
  displayName: 'Move',
  paths: [
    'M896 298.667h-768c-23.552 0-42.667-19.115-42.667-42.667s19.115-42.667 42.667-42.667h768c23.552 0 42.667 19.115 42.667 42.667s-19.115 42.667-42.667 42.667zM896 384h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667zM128 554.667h768c23.552 0 42.667 19.115 42.667 42.667s-19.115 42.667-42.667 42.667h-768c-23.552 0-42.667-19.115-42.667-42.667s19.115-42.667 42.667-42.667zM128 725.333h768c23.552 0 42.667 19.115 42.667 42.667s-19.115 42.667-42.667 42.667h-768c-23.552 0-42.667-19.115-42.667-42.667s19.115-42.667 42.667-42.667z'
  ],
  canvasPaths: canvasIconPaths(draggableIcon)
})
